<template>
  <div>
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container nav-container">
        <div class="logo">
          <i class="fa fa-navicon"></i>
          <span>{{ $t('companyName') }}</span>
        </div>
        <ul class="nav-links">
          <li v-for="(item, index) in $t('navItems')" :key="index">
            <a :class="{ active: $store.state.activeNavbar === item.id }" @click="handleClickNavbar(item.id)">
              {{ item.title }}
            </a>
          </li>
        </ul>
        <el-button-group>
          <el-button type="primary" style="background-color: #1a73e8;border-color: #1a73e8;"
                     @click="showContactDialog">
            {{ $t('head_touch_button') }}
          </el-button>
          <el-button type="primary" style="background-color: #1a73e8;border-color: #1a73e8;margin-left: 5px;"
                     @click="changeLanguage">
            {{ $t('head_language_button') }}
          </el-button>
        </el-button-group>
      </div>
    </header>

    <!-- 联系我们对话框 -->
    <el-dialog
        :visible.sync="contactDialogVisible"
        title="Contact Us"
        width="40%"
        center
    >
      <el-form :model="contactForm" label-width="120px">
        <el-form-item :label="$t('contact_name')">
          <el-input v-model="contactForm.name" :placeholder="$t('contact_name')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('contact_phone')">
          <el-input v-model="contactForm.phone" :placeholder="$t('contact_phone')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('contact_email')">
          <el-input v-model="contactForm.email" :placeholder="$t('contact_email')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('contact_service')">
          <el-select v-model="contactForm.service" :placeholder="$t('contact_service')" style="width: 100%;">
            <el-option
                v-for="service in $t('contact_services') "
                :key="service.title"
                :label="service.title"
                :value="service.title"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('contact_message')">
          <el-input
              v-model="contactForm.message"
              type="textarea"
              :rows="4"
              :placeholder="$t('contact_message')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="contactDialogVisible = false">{{ $t('contact_cancel') }}</el-button>
                <el-button type="primary" @click="submitContactForm">{{ $t('contact_submit') }}</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: `Head`,
  data() {
    return {
      contactDialogVisible: false,
      contactForm: {
        name: '',
        phone: '',
        email: '',
        service: '',
        message: ''
      },
    };
  },
  methods: {
    handleClickNavbar(val) {
      if (this.$store.state.activeNavbar !== val) {
        this.$router.push(val)
        this.$store.commit('setActiveNavbar', val)
      }
    },
    // 显示联系对话框
    showContactDialog() {
      this.contactForm.name = ""
      this.contactForm.phone = ""
      this.contactForm.email = ""
      this.contactForm.service = ""
      this.contactForm.message = ""
      this.contactDialogVisible = true
    },
    submitContactForm() {
      const url = 'http://112.15.115.103:8084/prod-api/web/contact/add';
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const loading = this.fullscreenLoading()
      axios.post(url, this.contactForm, config).then(() => {
        this.contactDialogVisible = false
        loading.close()
      }).catch(error => {
        this.contactDialogVisible = false
        console.error('Error:', error)
        loading.close()
      });
    },
    changeLanguage() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
    },
  }
}
</script>

<style scoped>

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏样式 */
.navbar {
  background-color: rgba(18, 18, 18, 0.8);
  backdrop-filter: blur(10px);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.logo {
  font-size: 24px;
  font-weight: 700;
  color: #1a73e8;
  display: flex;
  align-items: center;
}

.logo i {
  margin-right: 10px;
  color: #1a73e8;
}

.nav-links {
  display: flex;
  list-style: none;
}

.nav-links li {
  margin-left: 30px;
}

.nav-links a {
  text-decoration: none;
  color: #e0e0e0;
  font-weight: 500;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  cursor: pointer;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: #1a73e8;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.nav-links a:hover, .nav-links a.active {
  color: #1a73e8;
}

.nav-links a:hover::after, .nav-links a.active::after {
  width: 100%;
}

</style>
